import functions from "./functions.js";

$(function () {

    const $form = $('.booking-form');
    const form = $form[0];

    if (!form) {
        return;
    }

    const booking = {
        $form: null,
        $payment: null,
        $calculation: null,
        calc: [],
        persons: null,
        promoDiscount: null,
        totalAmount: null,
        totalAmountConverted: null,
        subscirbed: false,

        init() {
            booking.$form = $(".booking-form");
            booking.$calculation = $(".table-calculation");
            booking.$payment = $(".payment-details");
            booking.params = {};


            booking.$calculation.find("*[data-calc]").each(function (index) {
                let item = JSON.parse($(this).attr('data-calc'));
                item.inCalc = item.isOptional ? 0 : 1;
                booking.calc.push(item);
            });

            booking.$calculation.find('input[type="checkbox"]').change(function (e) {
                let $row = $(this).closest('tr');
                let $quantity = $row.find('select.quantity');
                let value = +$quantity.val();
                let checked = $(this).is(':checked') ? 1 : 0;

                if (checked && !value) {
                    $quantity.prop('value', 1);
                } else if (!checked && value) {
                    $quantity.prop('value', 0);
                }

                booking.calculate($(this));
            });

            $(".btn-promo-code").on('click', e => {
                let params = {};
                params['language'] = functions.getLang();
                params['promoCode'] = $("input[name='promoCode']").val();
                params['unitId'] = $("input[name='promoCode']").attr('data-unitid');

                $.post('/services/promoCode/', params).then(response => {
                    if (response.msg) $('.promo-code-output').removeClass('d-none').text(response.msg);

                    if (response.status == true) {
                        booking.promoCodeData = response;
                        booking.promoCodeData.promoCode = params['promoCode'];
                        
                        $(".btn-promo-code").attr('disabled', true);
                        booking.applyDiscount();

                    }
                    setTimeout(() => {
                        !response.status && $(".promo-code-output").addClass('d-none');
                    }, 5000);
                });
            });


            booking.$calculation.find('select.quantity').change(function (e) {
                let $row = $(this).closest('tr');
                let $checkbox = $row.find('input[type="checkbox"]');
                let value = +$(this).val();

                if (value && !$checkbox.is(':checked')) {
                    $checkbox.prop('checked', true);
                } else if (!value && $checkbox.is(':checked')) {
                    $checkbox.prop('checked', false);
                }

                booking.calculate($(this));
            });

            booking.total();

            booking.$form.on('submit', e => {

                if ( ! booking.$payment.find("[name='paymentType']")[0].checkValidity()) {
                    e.preventDefault();
                    booking.$payment.find("[name='paymentType']")[0].reportValidity()
                    return;
                }

                let $newsletterSubscribe  = $("[name='newsletter_subscribe']");

                if ($newsletterSubscribe && $newsletterSubscribe.is(':checked') && ! booking.subscirbed)
                {
                    e.preventDefault();
                    let params = {};
                    let email = $("[name='email']").val();
                    params['language'] = functions.getLang();
                    params.email = email;
                    params['recaptchaType'] = 'enterprise';
                    
                    grecaptcha.enterprise.ready(function () {
                        grecaptcha.enterprise.execute(functions.getRecaptchaKey(), { action: 'contact' }).then((token) => {
                            params['gRecaptchaToken'] = token;

                            $.post('/services/mailchimp/', params).then(response => {
                                if (response.status)
                                {
                                    booking.subscirbed = true;
                                    booking.$form.submit();
                                }
                                else
                                {
                                    $(".done-message").html(response.data).removeClass('d-none').addClass(response.status ? 'bg-warning' : 'bg-danger');
                                    setTimeout(() => { 
                                        $(".done-message").html('').addClass('d-none');
                                    }, 4000);
                                }
                            });
                        });
                    });
                }
                else
                {
                    booking.submit();
                }

            });

        },
        submit() {

            $.each(booking.calc, function(key, item) {
                if ( ! item.inCalc) {
                    delete booking.calc[key];
                } else if (item.itemDefinitionId.categoryId.key == 'baseRate') {
                    let $guestsPerProduct = $("[data-guests-parentId='" + item.parentId + "']");
                    let guests = [];

                    if ($guestsPerProduct.length) {
                        $guestsPerProduct.find('[data-guests]').each(function (index) {
                            let g = +$(this).data('guests');
                            guests[index] = {
                                firstName : $(this).find("input[name='firstName" + g + "']").val(),
                                lastName : $(this).find("input[name='lastName" + g + "']").val(),
                                age : $(this).find("input[name='age" + g + "']").val()
                            };
                        });
                        booking.calc[key].guestsData = guests;
                    }
                }
            });

            booking.params.paymentType = booking.$payment.find("[name='paymentType']:checked").val();
            booking.params.calc = JSON.stringify(booking.calc);
            booking.params.requestId = Math.floor(Math.random() * ((9999999 - 1000000) + 1) + 1000000);

            $.each(booking.params, function (key, param) {
                $('<input>').attr({
                    type: 'hidden',
                    name: key,
                    value: param
                }).appendTo(booking.$form);
            });

        },
        calculate($elem) {
            let $row = $elem.closest('tr');

            let $checkbox = $row.find('input[type="checkbox"]');
            let checked = $checkbox.is(':checked') ? 1 : 0;
            let id = $checkbox.attr('id');

            let $quantity = $row.find('select.quantity:visible');
            let quantity = null;

            if ($quantity.length) {
                quantity = +$quantity.val();
            }

            $.each(booking.calc, function (key, calc) {
                if (calc.id == id) {

                    if (quantity == null) {
                        quantity = booking.calc[key].quantity;
                    }

                    booking.calc[key].inCalc = checked;
                    booking.calc[key].quantity = (quantity || 1);
                    booking.calc[key].total = booking.itemTotal(booking.calc[key]);
                    booking.calc[key].totalConverted = booking.itemTotalConverted(booking.calc[key]);

                    $row.find('.item-total-amount').html(functions.formatMoney(booking.calc[key].total, 2, ',', '.'));
                    $row.find('.item-total-amount-converted').html(functions.formatMoney(booking.calc[key].totalConverted, 2, ',', '.'));
                }
            });


            booking.total();
        },
        itemTotal(item) {
            let itemTotal = 0.00;

            if (item.paymentTypeId.key) {

                if ($.inArray(item.paymentTypeId.key, ['perPerson', 'perPersonPerDay', 'perPersonPerWeek']) > -1) {
                    itemTotal = +item.quantity * +item.price;
                } else {
                    itemTotal = +item.price;
                }
            } else {
                itemTotal = +item.quantity * +item.price;
            }

            return itemTotal;
        },
        itemTotalConverted(item) {
            let itemTotal = 0.00;

            if (item.paymentTypeId.key) {

                if ($.inArray(item.paymentTypeId.key, ['perPerson', 'perPersonPerDay', 'perPersonPerWeek']) > -1) {
                    itemTotal = +item.quantity * +item.priceConverted;
                } else {
                    itemTotal = +item.priceConverted;
                }
            } else {
                itemTotal = +item.quantity * +item.priceConverted;
            }

            return itemTotal;
        },
        total() {
            booking.totalAmount = 0.00;
            booking.totalAmountConverted = 0.00;

            $.each(booking.calc, function (key, calc) {
                if (!calc.onSpot && calc.inCalc) {
                    booking.totalAmount += booking.itemTotal(calc);
                    booking.totalAmountConverted += booking.itemTotalConverted(calc);
                }
            });

            $('.total-amount').html(functions.formatMoney(booking.totalAmount, 2, ',', '.'));
            $('.total-amount-converted').html(functions.formatMoney(booking.totalAmountConverted, 2, ',', '.'));

            const advancePaymentPercent = $('[data-advancePaymentPercent]').attr('data-advancepaymentpercent');
            const advance = booking.totalAmount * (advancePaymentPercent / 100);
            const rest = booking.totalAmount - advance;

            booking.$payment.find('.advance').html(functions.formatMoney(advance, 2, ',', '.'));
            booking.$payment.find('.rest').html(functions.formatMoney(rest, 2, ',', '.'));

            const advanceConverted = booking.totalAmountConverted * (advancePaymentPercent / 100);
            const restConverted = booking.totalAmountConverted - advanceConverted;

            booking.$payment.find('.advance-converted').html(functions.formatMoney(advanceConverted, 2, ',', '.'));
            booking.$payment.find('.rest-converted').html(functions.formatMoney(restConverted, 2, ',', '.'));

        },
        applyDiscount() {
            booking.$calculation.each(function (index) {

                $(this).find(".promoDiscountItem").remove();
                let promoDiscountItem = JSON.parse($(this).find("*[data-calc]:first").attr('data-calc'));
                let promoDiscountItemId = promoDiscountItem.id + '_' + 114;

                let total = 0;
                let totalConverted = 0;
                $(this).find("*[data-calc]").each(function (index) {
                    let item = JSON.parse($(this).attr('data-calc'));
                    let quantity = item.isOptional ? $(this).find('select.quantity').val() : item.quantity;
                    if ( ! item.onSpot && quantity) {
                        total += +item.price * +quantity;
                        totalConverted += +item.priceConverted * +quantity;
                    }
                });
                // total += total * 2.5/100;

                $.each(booking.calc, function (key, calc) {
                    if (calc && calc.id == promoDiscountItemId) {
                        booking.calc.splice(key, 1);
                    }
                });
                // debugger;
                let discountAmount = '';
                let discountAmountConverted = '';

                if (booking.promoCodeData.amount) {
                    discountAmount = -1 * booking.promoCodeData.amount;
                    discountAmountConverted = -1 * booking.promoCodeData.amountConverted;
                } else {
                    discountAmount = (-1 * (total * (booking.promoCodeData.percent/100)));
                    discountAmountConverted = (-1 * (totalConverted * (booking.promoCodeData.percent/100)));
                }

                promoDiscountItem.id = promoDiscountItemId;
                promoDiscountItem.itemDefinitionId.id = 114;
                promoDiscountItem.itemDefinitionId.text = 'Promo';
                promoDiscountItem.itemDefinitionId.categoryId.id = 80;
                promoDiscountItem.itemDefinitionId.categoryId.key = 'discount';
                promoDiscountItem.itemDefinitionId.objectGroupId.id = 1;
                promoDiscountItem.itemDefinitionId.objectGroupId.key = 'accommodation';
                promoDiscountItem.itemDefinitionId.typeId.id = 2;
                promoDiscountItem.itemDefinitionId.typeId.key = 'supplement';
                promoDiscountItem.priceIn = discountAmount;
                promoDiscountItem.price = discountAmount;
                promoDiscountItem.totalIn = discountAmount;
                promoDiscountItem.total = discountAmount;
                promoDiscountItem.priceConverted = discountAmountConverted;
                promoDiscountItem.noteHidden = booking.promoCodeData.promoCode;
                promoDiscountItem.skipCalculate = true;
                promoDiscountItem.inCalc = true;
                promoDiscountItem.promoCodeId = booking.promoCodeData.id;
                promoDiscountItem.quantity = 1;

                let hideConverted = functions.getLang() == 'hr' ? '' : 'd-none';

                $(this).find('.promo-item-wrap').remove();

                $('<tr data-calc=\'' + JSON.stringify(promoDiscountItem).replace(/'/g, '&apos;').replace(/"/g, '&quot;') + '\'>' +
                    '<td class="px-1 px-lg-3">' +
                        '<div class="form-check">' +
                            '<input type="checkbox" class="form-check-input" ' +
                                'id="'+ promoDiscountItem.id +'" ' +
                                'name="'+ promoDiscountItem.id +'" checked disabled>' +
                        '</div>' +
                    '</td>' +

                    '<td class="px-1 px-lg-3">' +
                        promoDiscountItem.itemDefinitionId.text +
                        '<div class="d-flex d-md-none row align-items-center">' +
                            '<div class="col-12 mt-1">' +
                                'Ukupno: ' +
                                '<span class="item-total-amount">' +
                                    functions.formatMoney(discountAmount, 2, ',', '.') +
                                '</span> €' +
                            '</div>' +
                        '</div>' +
                    '</td>' +

                    '<td class="px-1 px-lg-3 text-center text-nowrap d-none d-md-table-cell">' +
                        promoDiscountItem.quantity +
                    '</td>' +

                    '<td class="px-1 px-lg-3 text-end text-nowrap d-none d-md-table-cell">' +
                        functions.formatMoney(discountAmount, 2, ',', '.') + ' €' +
                    '</td>' +

                    '<td class="px-1 px-lg-3 text-end text-nowrap d-none d-md-table-cell">' +
                        '<span class="item-total-amount">' +
                            functions.formatMoney(discountAmount, 2, ',', '.') +
                        '</span> €' +
                    '</td>' +

                '</tr>').insertBefore($('.promo-placeholder'));

                booking.calc.push(promoDiscountItem);
                booking.calculate($(this).find(".promoDiscountItem"), 1);
            });

            booking.total();

        },
    }

    booking.init();
});